import React from "react";
import {connect} from "react-redux";
import JobPaymentPopupInput from "./JobPaymentPopupInput";


const JobPaymentPopupACHInputs = (props) => {

  const {achInfo} = props;

  return (
    <div className="job-payment__container">
      <div className="job-payment__block flex flex--center job-payment__container">
        <JobPaymentPopupInput key={"accountNumber"}
                              property={"accountNumber"}
                              value={achInfo.accountNumber}/>
      </div>
      <div className="job-payment__block flex flex--center job-payment__container">
        <JobPaymentPopupInput key={"routingNumber"}
                              property={"routingNumber"}
                              value={achInfo.routingNumber}/>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {achInfo} = store.jobPaymentState;

  return {
    achInfo,
  };
};

export default (
  connect(mapStateToProps)(JobPaymentPopupACHInputs)
)
